import React, { useState, useEffect, Dispatch, SetStateAction } from 'react';
import { PageHero } from '../../../components/pageHero/PageHero';
import { endpoints } from 'endpoints.config';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { FixedSizeList, areEqual } from "react-window";
import DandD_Icon from "../../../images/DandD_Icon.png";
import { Spinner } from 'components/spinner/Spinner';
import { WondeApi } from 'api/wondeApi';
import WarningIcon from '../../../images/Icon_Warning.png';
import { useToast } from 'hooks/useToast';
import { PreviouslyMatchedRecords } from '../wIFeatures/PreviouslyMatchedRecords';

type WIStep2Props = {
  setCurrentStep: Dispatch<SetStateAction<number>>;
  setWondeIntegration: Dispatch<SetStateAction<boolean>>;
  currentSynOpt: string;
};

interface ItemProps {
  provided: any;
  item: any;
  style: any;
  isDragging: any;
}

interface getStyleProps {
  draggableStyle: any;
  virtualStyle: any;
  isDragging: any;
};

export const WIStep2: React.FC<WIStep2Props> = ({ 
  setCurrentStep, 
  setWondeIntegration,
  currentSynOpt, 
}) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [submitUrl, setSubmitUrl] = useState<string>("");
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [generalError, setGeneralError] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [pageName, setPageName] = useState<string | null>(null);
  const [originalRecordsData, setOriginalRecordsData] = useState<any>([]);
  const [recordsData, setRecordsData] = useState<any>(null);
  const [selectedWondeItem, setSelectedWondeItem] = useState<any>(null); 
  const [selectedGetSetItem, setSelectedGetSetItem] = useState<any>(null); 
  const [matchedRecordsData, setMatchedRecordsData] = useState<any>([]);
  const [updatingRecords, setUpdatingRecords] = useState<boolean>(false);
  const [endpointTableErr, setEndpointTableErr] = useState<boolean>(false);

  const successToast = useToast("Successfully submitted");

  useEffect(() => {
    document.body.style.overflowY = '';
  }, []);  

  useEffect(() => {
    if(currentSynOpt){
      loadData();
    }
  }, [currentSynOpt]);

  useEffect(() => {
    if(endpointTableErr){
      setCurrentStep(3);
    }
  }, [endpointTableErr]);

  useEffect(() => {
    if(selectedWondeItem && selectedGetSetItem){
      matchSelectedRecords();
    }
  }, [selectedWondeItem, selectedGetSetItem]);

  useEffect(() => {
    if(updatingRecords){
      setRecordsData(recordsData);
      setMatchedRecordsData(matchedRecordsData);
      setUpdatingRecords(false);
    }
  }, [updatingRecords, recordsData, matchedRecordsData]);   

  const loadData = async () => {
    setPageName(`Sync ${currentSynOpt} Records`);

    const currentListUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.classStep2ManualMatchList :
      endpoints.wondeIntegration.pupilStep2ManualMatchList;

    const currentSubmitUrl = currentSynOpt === "Class" ?
      endpoints.wondeIntegration.classStep2ManualMatch :
      endpoints.wondeIntegration.pupilStep2ManualMatch;

    setSubmitUrl(currentSubmitUrl);    

    const result = await WondeApi.getWondeUnmatchedRecords(currentListUrl);

    if (!result.error) {
      let wondeRecordsTypeList = currentSynOpt === "Class" ?
        result.data.unmatchedWondeClasses :
        result.data.unmatchedWondePupils;

      wondeRecordsTypeList = wondeRecordsTypeList === null ? [] : wondeRecordsTypeList;

      let getSetRecordsTypeList = currentSynOpt === "Class" ?
        result.data.unmatchedClasses :
        result.data.unmatchedPupils;

      getSetRecordsTypeList = getSetRecordsTypeList === null ? [] : getSetRecordsTypeList;

      const wondeRecords = wondeRecordsTypeList.map((item: any) => {
        return { 
          "id": item.id, 
          "recordClassName": item.name, 
          "recordYearGroup": item.applicableYear,
          "recordKeyStage": currentSynOpt === "Class" ? item.keyStage : null,
          "recordEmail": null,
          "recordsType": "wonde",
        }
      });      

      const getSetRecords = getSetRecordsTypeList.map((item: any) => {
        return { 
          "id": item.id, 
          "recordClassName": item.name, 
          "recordYearGroup": item.applicableYear,
          "recordKeyStage": currentSynOpt === "Class" ? item.keyStage : null,
          "recordEmail": null,
          "recordsType": "getset",
        }
      });

      const inititalData = [
        {
          recordsType: "wonde",
          columnName: "Unmatched Wonde Records",
          records: wondeRecords
        },
        {
          recordsType: "getset",
          columnName: "Unmatched Get Set 4 Education records",
          records: getSetRecords
        }      
      ];
      
      setOriginalRecordsData(JSON.parse(JSON.stringify(inititalData)));
      setRecordsData(JSON.parse(JSON.stringify(inititalData)));
    }
    
    if (result.error) {
      setEndpointTableErr(true);
      //setGeneralError("An error occurred, please try again.");
    }

    setLoading(false);
  };
  
  const onDragEnd = (results: any) => {
    if(results && results.destination && results.destination.droppableId === "droppable_container_0"){
      setSelectedWondeItem(null);
      setSelectedGetSetItem(null);
    } else {
      setSelectedWondeItem(parseInt(results.draggableId));
    }
  } 

  const onDragUpdate = (results: any) => {
    let recordsDataCopy = recordsData;

    if(results && results.destination && results.destination.droppableId === "droppable_container_0"){
      setSelectedWondeItem(null);
      setSelectedGetSetItem(null);
    } else if (results && results.destination) {
      recordsDataCopy[1].records.map((item: any, index: number) => {   
        if(index === results.destination.index){
          setSelectedGetSetItem(item.id);
        }

        return item;
      });
    }
  }

  const matchSelectedRecords = () => {
    let recordsDataCopy = recordsData;
    let matchedRecordsDataCopy = matchedRecordsData;
    let wondeRecordMatchIndex = 0;
    let getSetRecordMatchIndex = 0;
    let selectedWondeItemObj = recordsDataCopy[0].records.filter((item: any, index: number) => {
      if(item.id === selectedWondeItem){
        wondeRecordMatchIndex = index;
      }
      
      return item.id === selectedWondeItem;
    });
    let selectedGetSetItemObj = recordsDataCopy[1].records.filter((item: any, index: number) => {
      if(item.id === selectedGetSetItem){
        getSetRecordMatchIndex = index;
      }

      return item.id === selectedGetSetItem; 
    });

    matchedRecordsDataCopy.push({
      "wondeRecord": selectedWondeItemObj[0],
      "getSetRecord": selectedGetSetItemObj[0],
    });

    recordsDataCopy[0].records.splice(wondeRecordMatchIndex, 1);
    recordsDataCopy[1].records.splice(getSetRecordMatchIndex, 1);

    setRecordsData(recordsDataCopy);
    setMatchedRecordsData(matchedRecordsDataCopy);
    setSelectedWondeItem(null);
    setSelectedGetSetItem(null);
  };

  const unmatchRecord = (item: any, item_index: number) => {
    let recordsDataCopy = recordsData;
    let wondeRecordUnmatchIndex = 0;
    let getSetRecordUnmatchIndex = 0;    
    let matchedRecordsDataCopy = matchedRecordsData;

    matchedRecordsDataCopy.splice(item_index, 1);

    originalRecordsData[0].records.map((original_item: any, index: number) => {
      if(original_item.id === item.wondeRecord.id){
        wondeRecordUnmatchIndex = index;
      }
      return original_item;
    });

    originalRecordsData[1].records.map((original_item: any, index: number) => {
      if(original_item.id === item.getSetRecord.id){
        getSetRecordUnmatchIndex = index;
      }
      return original_item;
    });

    recordsDataCopy[0].records.splice(wondeRecordUnmatchIndex, 0, item.wondeRecord);
    recordsDataCopy[1].records.splice(getSetRecordUnmatchIndex, 0, item.getSetRecord);

    setRecordsData(recordsDataCopy);
    setMatchedRecordsData(matchedRecordsDataCopy);
    setUpdatingRecords(true);
  };

  const submitSelectedRecords = async () => {
    if(matchedRecordsData.length > 0){
      setIsSubmitting(true);

      const matchedRecordsDataCopy = matchedRecordsData;
  
      const selectedRecords = matchedRecordsDataCopy.map((item: any) => {
        return currentSynOpt === "Class" ?
          { "classID": item.getSetRecord.id, "wondeClassID": item.wondeRecord.id, } :
          currentSynOpt === "Pupil" ?
          { "pupilID": item.getSetRecord.id, "wondePupilID": item.wondeRecord.id, } :
          { "schoolUserID": item.getSetRecord.id, "wondeSchoolUserID": item.wondeRecord.id, };
      });
  
      const result = await WondeApi.submitSelectedMatchedWondeRecords(selectedRecords, submitUrl);
  
      if (!result.error) {
        successToast();
        window.scrollTo(0, 0);
        setCurrentStep(3);
      }
  
      if (result.error) {
        setError("An error occurred, please try again.");
        setIsSubmitting(false);
        window.scrollTo(0, 0);
      }
    } else {
      window.scrollTo(0, 0);
      setCurrentStep(3);
    }
  };

  function getStyle({ draggableStyle, virtualStyle, isDragging }: getStyleProps) {
    const combined = {
      ...virtualStyle,
      ...draggableStyle
    };

    const grid = 5;

    const result = {
      ...combined,
      height: isDragging ? combined.height : combined.height - grid,
      width: isDragging
        ? draggableStyle.width
        : `calc(${combined.width} - ${grid * 2}px)`,
      marginBottom: grid
    };
  
    return result;
  }  

  const Item = ({ provided, item, style, isDragging }: ItemProps) => {
    return (
      <div 
        className={"RecordBlock" + (isDragging || selectedGetSetItem === item.id ? " Highlight" : "")} 
        {...provided.draggableProps} 
        {...provided.dragHandleProps} 
        ref={provided.innerRef}
        style={getStyle({
          draggableStyle: provided.draggableProps.style,
          virtualStyle: style,
          isDragging
        })}          
      >
        <div className="Inner">
          <div className="RBCol Col1">
            {item.recordsType === "wonde" ?
              <div className="IconAndTxt">
                <div className="RBIcon"><img src={DandD_Icon} alt={item.recordClassName} /></div>
                <div className="RBTxt">{item.recordClassName}</div>
              </div>
              :
              item.recordClassName
            }
          </div>
          <div className="RBCol Col2">
            {item.recordYearGroup}
          </div>
          {currentSynOpt === "Class" &&
            <div className="RBCol Col3">{item.recordKeyStage}</div>
          }
        </div>
      </div>
    );
  };

  const Row = React.memo(function Row(props: any) {
    const { data: items, index, style } = props;
    const item = items[index];

    if (!item) {
      return null;
    }
  
    return (
      <Draggable key={"draggable_container_key_" + item.id.toString()} draggableId={item.id.toString()} index={index} isDragDisabled={item.recordsType === "getset"}>
        {(provided, snapshot) => (<Item provided={provided} item={item} style={style} isDragging={snapshot.isDragging} />
      )}
      </Draggable>
    );
  }, areEqual);

  return (
    <div className="PageContent WondeIntegrationPage Step2">
      <PageHero title={pageName ?? ''} />
      <div className="WidthContent">
        <div className="TopInfoRow">
          <div className="LeftSide">
            <h2>Unmatched Records</h2>
          </div>
          <div className="RightSide">
            {/*<p>Step 2 of 4</p>*/}
          </div>
        </div>
        <p>Here are unmatched records between your Wonde and Get Set records. Drag the Wonde {currentSynOpt === "Class" ? "class" : "pupil"} records and drop them with the Get Set records you would like to link them to.</p>

        {error &&
          <div className="ErrorTxt">{error}</div>
        }

        {loading ? 
            <div className="LoadingPanel">
              <div className="LPInfo">
                <Spinner color={'#f59e16'} />
                <div className="LPTxt">Hang tight...we are just checking your data!</div>
              </div>
            </div>
          :
          <>
            {generalError ?
              <div className="ErrorPageStatus">
                <img src={WarningIcon} alt="Wonde Logo" className="WondeLogo" />
                <div className="Txt">{generalError}</div>
              </div>
              :
              <>
                {recordsData && recordsData.length > 0 &&
                  <>
                    {isSubmitting &&
                      <div className="WILoadingPanel">
                        <Spinner color={'#f59e16'} />
                      </div>
                    }

                    <div className="RecordListColumns">
                      <DragDropContext onDragEnd={onDragEnd} onDragUpdate={onDragUpdate}>
                        {recordsData.map((item: any, list_col_index: number) => {
                          return (
                            <div className="ListCol" key={list_col_index}>
                              {item.records && item.records.length > 0 &&
                                <>
                                  <h4>{item.columnName}</h4>

                                  <div className={"LCHdrRow " + (list_col_index === 0 ? " FirstCol" : "")}>
                                    <div className="LCHdr Col1">
                                      {currentSynOpt === "Pupil" ? "Pupil name" : "Class name"}
                                    </div>
                                    <div className={"LCHdr Col2" + (currentSynOpt === "Class" ? " ClassBlock" : "")}>
                                      Year group
                                    </div>
                                    {currentSynOpt === "Class" &&
                                      <div className="LCHdr Col3">Key stage</div>
                                    }
                                  </div>

                                  <div className="RecordsListContainer">
                                    <Droppable 
                                      droppableId={"droppable_container_" + list_col_index}
                                      mode="virtual"
                                      renderClone={(provided, snapshot, rubric) => (
                                        <Item
                                          provided={provided}
                                          isDragging={snapshot.isDragging}
                                          item={item.records[rubric.source.index]}
                                          style={null}
                                        />
                                      )}                                      
                                    >
                                      {(provided: any, snapshot: any) => {
                                        const itemCount = snapshot.isUsingPlaceholder ? item.records.length + 1 : item.records.length;

                                        return (
                                          <FixedSizeList
                                            height={440}
                                            itemCount={itemCount}
                                            itemSize={45}
                                            width={"100%"}
                                            outerRef={provided.innerRef}
                                            itemData={item.records}
                                            className="task-list"
                                          >
                                            {Row}
                                          </FixedSizeList>
                                        );
                                      }}
                                    </Droppable>
                                  </div>
                                </>
                              }

                              {(!item.records || item.records.length <= 0) && 
                                <>
                                  <h4>{item.columnName}</h4>
                                  <p>There are no records.</p>                                
                                </>
                              }                
                            </div>
                          );
                        })}
                      </DragDropContext>
                    </div>

                    <div className="LineSpacer4"></div>
                    <div className="LineSpacer5"></div>

                    <h4>Matched Records</h4>
                    {matchedRecordsData.length <= 0 &&
                      <div className="NoMatchedRecordsPanel">
                        <div className="EmptyMsgBlock">
                          <div className="Inner">
                            <p>No records matched</p>
                          </div>
                        </div>
                      </div>
                    }

                    {matchedRecordsData.length > 0 &&
                      <div className="MatchedRecordsPanel">
                        <div className="SelectedRecordRow TopRow">
                          <div className="SRCol Col1">
                            <div className="RRDetails">
                              <div className="LCHdrRow">
                                <div className="LCHdr Col1">
                                  {currentSynOpt === "Pupil" ? "Pupil name" : "Class name"}
                                </div>
                                <div className="LCHdr Col2">
                                  Year group
                                </div>
                                {currentSynOpt === "Class" && <div className="LCHdr Col3">Key stage</div>}
                              </div>                       
                            </div>
                          </div>
                          <div className="SRCol Col2"></div>
                          <div className="SRCol Col3">
                            <div className="RRDetails">
                              <div className="LCHdrRow">
                                <div className="LCHdr Col1">
                                  {currentSynOpt === "Pupil" ? "Pupil name" : "Class name"}
                                </div>
                                <div className="LCHdr Col2">
                                  Year group
                                </div>
                                {currentSynOpt === "Class" && <div className="LCHdr Col3">Key stage</div>}
                              </div>                         
                            </div>
                          </div>
                          <div className="SRCol Col4"></div>                                                                        
                        </div>

                        <div className="MRInner">
                          {matchedRecordsData.map((item: any, index: number) => {
                            return (
                              <div className="SelectedRecordRow" key={index}>
                                <div className="SRCol Col1">
                                  <div className="RRDetails">
                                    <div className="RecordBlock">
                                      <div className="Inner">
                                        <div className="RBCol Col1">{item.wondeRecord.recordClassName}</div>
                                        <div className="RBCol Col2">
                                          {item.wondeRecord.recordYearGroup}
                                        </div>
                                        {currentSynOpt === "Class" && <div className="RBCol Col3">{item.wondeRecord.recordKeyStage}</div>}
                                      </div>
                                    </div>                        
                                  </div>
                                </div>
                                <div className="SRCol Col2"></div>
                                <div className="SRCol Col3">
                                  <div className="RRDetails">
                                    <div className="RecordBlock">
                                      <div className="Inner">
                                        <div className="RBCol Col1">{item.getSetRecord.recordClassName}</div>
                                        <div className="RBCol Col2">
                                          {item.getSetRecord.recordYearGroup}
                                        </div>
                                        {currentSynOpt === "Class" && <div className="RBCol Col3">{item.getSetRecord.recordKeyStage}</div>}
                                      </div>
                                    </div>                         
                                  </div>
                                </div>
                                <div className="SRCol Col4">
                                  <div className="Btn BtnWhiteOrange" onClick={() => unmatchRecord(item, index)}>Unmatch</div>
                                </div>                                                                        
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    }
                  </>
                }

                <PreviouslyMatchedRecords currentSynOpt={currentSynOpt} />

                <div className="BtmBtns">
                  <div className="Btn BtnWhite LeftBtn" onClick={() => {
                    window.scrollTo(0, 0);
                    setWondeIntegration(false);
                  }}>Cancel</div>
                  <div className="Btn BtnOrange RightBtn" onClick={() => submitSelectedRecords()}>Confirm</div>
                </div> 
              </>
            }         
          </>
        }
      </div>
    </div>
  );
};